import {Carousel} from 'react-responsive-carousel'

import 'react-responsive-carousel/lib/styles/carousel.min.css'

import './Carousel.module.scss'

export default Carousel
